import React from 'react'
import { Wrapper } from './styles'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/free-solid-svg-icons'

type Props = {
  text: string
  style?: React.CSSProperties | undefined
}

export default function HighlightedInfo({ text, style }: Props) {
  return (
    <Wrapper style={style}>
      <FontAwesomeIcon icon={faInfoCircle} /> {text}
    </Wrapper>
  )
}
